import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SoundtrackTab.css';

function SoundtrackTab({ movie }) {
  const [soundtrackData, setSoundtrackData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSoundtrack = async () => {
      if (!movie || !movie.id) return;
      
      setIsLoading(true);
      setError(null);
      
      try {
        const baseUrl = 'https://api.qreel.efraprojects.com';
        const response = await axios.get(`${baseUrl}/api/movie/soundtrack/${movie.id}`);
        
        console.log("Soundtrack API response:", response.data);
        setSoundtrackData(response.data.soundtrack);
      } catch (err) {
        console.error("Error fetching soundtrack:", err);
        setError("Failed to load soundtrack information");
      } finally {
        setIsLoading(false);
      }
    };

    fetchSoundtrack();
  }, [movie]);

  if (!movie) return <div>No movie selected</div>;
  if (isLoading) return <div className="loading-state">Loading soundtrack...</div>;

  return (
    <div className="soundtrack-tab">
      <h2>Soundtrack</h2>
      
      {error && (
        <div className="error-message">
          <p>{error}</p>
        </div>
      )}
      
      {soundtrackData && (
        <>
          <div className="album-info">
            {soundtrackData.image && (
              <img 
                src={soundtrackData.image} 
                alt={`${soundtrackData.album} cover`} 
                className="album-cover"
              />
            )}
            <div className="album-details">
              <h3>{soundtrackData.album || 'Soundtrack'}</h3>
              <p>Artist: {soundtrackData.artist || 'Various Artists'}</p>
              {soundtrackData.url && (
                <a 
                  href={soundtrackData.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="last-fm-link"
                >
                  View on Last.fm
                </a>
              )}
            </div>
          </div>
          
          {soundtrackData.tracks && soundtrackData.tracks.length > 0 ? (
            <div className="soundtrack-list">
              <h3>Tracks</h3>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Title</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  {soundtrackData.tracks.map((track, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        {track.url ? (
                          <a 
                            href={track.url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                          >
                            {track.name}
                          </a>
                        ) : (
                          track.name
                        )}
                      </td>
                      <td>
                        {track.duration ? 
                          `${Math.floor(track.duration / 60)}:${String(Math.floor(track.duration % 60)).padStart(2, '0')}` 
                          : "--:--"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="no-tracks">
              <p>Track listing not available for this soundtrack.</p>
              <p>Visit the Last.fm link above for more information.</p>
            </div>
          )}
        </>
      )}
      
      {!soundtrackData && !isLoading && !error && (
        <div className="no-soundtrack">
          <p>No soundtrack information available for this movie.</p>
        </div>
      )}
      
      <div className="soundtrack-note">
        <p>Soundtrack data provided by Last.fm API</p>
      </div>
    </div>
  );
}

export default SoundtrackTab;